import { Type } from 'class-transformer'
import * as Config from '../../constants/Config'
import { Device } from '../Device'

export class ConfigStore {

  public initialized: boolean = false

  @Type(() => Device)
  public device: Device = null

  public showRoomNameType: Config.RoomNameType = Config.RoomNameType.Json

  public showEventLogo: boolean = true

  public showDescription: boolean = true

  public clientLogoPath: string = null

  public eventTitle: string = null

  public busyRoomTitle: string = null

  public freeRoomTitle: string = null

  public nextRoomTitle: string = null

  public nextScroll: boolean = true

  public routerScroll: boolean = true

  public routerMin: number = 1

  public rotationInterval: number = Config.DEFAULT_EVENTS_ROTATION_INTERVAL

  public theme: Config.Theme = Config.Theme.Default

  public langCode: string = Config.DEFAULT_LANGUAGE
}
